export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Matrix.vue?vue&type=template&id=6f73b60a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/Matrix.vue?vue&type=template&id=6f73b60a&scoped=true
// module id = 1972
// module chunks = 31